import React from 'react'

export const Eyeball = ({ width = 40, height = 40, color = '#003087' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={width} height={height} rx="20" fill="#efefef" />
      <path
        d="M23.5 20C23.5 21.933 21.933 23.5 20 23.5C18.067 23.5 16.5 21.933 16.5 20C16.5 18.067 18.067 16.5 20 16.5C21.933 16.5 23.5 18.067 23.5 20Z"
        fill="#003087"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 28C26 28 30 22 30 20C30 18 26 12 20 12C14 12 10 18.0312 10 20C10 21.9687 14 28 20 28ZM25 20C25 22.7614 22.7614 25 20 25C17.2386 25 15 22.7614 15 20C15 17.2386 17.2386 15 20 15C22.7614 15 25 17.2386 25 20Z"
        fill="#003087"
      />
    </svg>
  )
}
